<template>

  <div class="wrapper">
  <div>
    <CButton  color="info" @click="openModal"><b>Add New iCare Group</b></CButton>
      <CRow class="mt-3">
      <div>
      </div>
        <CCol sm="12">
          <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <Datatable
                            :items="items"
                            :fields="fields"
                            :meta="meta"
                            @per_page="handlePerPage"
                            @pagination="handlePagination"
                            @search="handleSearch"
                            @sort="handleSort"
                            @is_active="handleIsActive"
                            :btn_show="true"
                            :btn_edit="true"
                            :btn_deactivate="true"
                            :btn_reactivate="true"
                            :btn_delete="false"
                            @show="handleShow"
                            @edit="handleEdit"
                            @deactivate="handleDeactivate"
                            @reactivate="handleReactivate"
                        />
                    </div>
                </div>
            </div>
        </div>
      </CCol>
    </CRow>
     <groupmodal></groupmodal>
    <alertmodal></alertmodal>
  </div>

  </div>
</template>

<script>
import Datatable from '@/components/datatables.vue'
import axios from 'axios';

import group from '@/services/coachgroup';
import groupmodal from './coachgroup_modal';

import alertmodal from '@/views/alert/modal.vue';
import EventBus from '@/eventBus';
import store from '@/store.js'

const token = localStorage.getItem('token');

export default {
  name: 'GroupTable',
  components: { Datatable, groupmodal, alertmodal },
  data () {
    return {
      form:{
        name:'',
        description:'',
        coach:''

      },
      updateSubmit: false,
      fields: [
          {key: 'name', sortable: false, },
          {key: 'description', sortable: false},
          {key: 'coach', sortable: false, label: 'Team Leader'},
          {key: 'is_active', sortable: false},
          {key: 'action', label: 'Action', sortable: false},
      ],
      items: [],
      meta: [],
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'name',
      sortByDesc: false,
      is_active: 1,
    }
   },
    created() {
      //this.loadData()
  },

   mounted (){
     this.loadData()

      EventBus.$on('TABLE_UPDATE', (data) => {
      if(data){
          this.loadData();
      }
    });
   },

  methods: {
    openModal: function () {
        //SET PERMISSION EACH FEATURE
        let Permission = store.state.user.authenticated.permission
        if (typeof Permission != 'undefined') {
          if(Permission.indexOf('Create/edit group (including edit coach & iCares for the group)') !== -1){
            //IF ALLOW
      var params = {title: 'Add New Group', mode:'create'}
      EventBus.$emit('OPEN_MODAL_GROUP', params)
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        }
      }
      //SET END
    },
     openShow: function(id){
        //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('View group') !== -1){
          //IF ALLOW
      group.getGroupbyID(id)
      .then(res => {
      var params = {title: 'Detail Coach Group', mode:'detail', data:res.data}
      EventBus.$emit('OPEN_DETAIL_COACH_GROUP', params)

      })
      this.$router.push({name:'Coach Group Detail',query: {Pud:id} })
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        }
      }
      //SET END
    },

    openModalEdit(id){
       //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Create/edit group (including edit coach & iCares for the group)') !== -1){
          //IF ALLOW
        var params = {title: 'Edit Group', mode:'edit', data:id}
        EventBus.$emit('OPEN_MODAL_GROUP', params)
        //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
          console.log(' open modal edit')
        }
      }
      //SET END
    },

    deactivate(id){
       //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete group') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to deactivate?")){
        group.deactivateGroup(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }
      }
      //SET END
    },

    reactivate(id){
       //SET PERMISSION EACH FEATURE
      let Permission = store.state.user.authenticated.permission
      if (typeof Permission != 'undefined') {
        if(Permission.indexOf('Delete group') !== -1){
          //IF ALLOW
      if(confirm("Do you really want to reactivate?")){
        group.reactivateGroup(id)
        .then(res => {
          EventBus.$emit('TABLE_UPDATE', true)
          var params = {title: 'Success', mode:'success', data:res.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }).catch ((err) => {
          var params = {title: 'Error', mode:'danger', data:err.response.data.message}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        })
      }
      //END ALLOW
        }else{
          //IF NOT
          var params = {title: 'Error', mode:'danger', data:'unautenticated'}
          EventBus.$emit('OPEN_MODAL_ALERT', params)
        }
      }
      //SET END
    },

     loadData() {
      let current_page = this.search == '' ? this.current_page:1
      var params = {
        headers: { "Authorization" : `Bearer ${token}` },
        page: this.current_page,
        per_page: this.per_page,
        q: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC':'ASC',
        is_active: this.is_active,
      }
      group.getGroupDataSource(params)
      .then(res => {
          let getData = res.data
          this.items = getData.data
          //this.is_active = res.is_active
          this.meta = {
              total: getData.total,
              current_page: getData.current_page,
              per_page: getData.per_page,
              from: getData.from,
              to: getData.to,
              is_active: res.is_active
          }
          if(this.items.description === null){
          this.description = ''
          }else{
          this.description = this.items.description
          }
          if(this.items.coach_id === null){
          this.coach_id = ''
          }else{
          this.coach_id = this.items.coach_id
          }
      }).catch ((err) => {
        var params = {title: 'Error', mode:'danger', data:err.response.data.message}
        EventBus.$emit('OPEN_MODAL_ALERT', params)
      })
    },
    handlePerPage(val) {
        this.per_page = val
        this.loadData()
    },

    handlePagination(val) {
        this.current_page = val
        this.loadData()
    },

    handleSearch(val) {
        this.search = val
        this.current_page = 1
        this.loadData()
    },

    handleSort(val) {
        this.sortBy = val.sortBy
        this.sortByDesc = val.sortDesc
        this.loadData()
    },

    handleIsActive(val) {
        this.is_active = val
        this.loadData()
    },

////HANDLE FUNCTION BUTTON ACTION////
    handleShow(val) {
        this.openShow(val)
    },
    handleEdit(val) {
        this.openModalEdit(val)
    },
    handleDeactivate(val) {
        this.deactivate(val)
    },
    handleReactivate(val) {
        this.reactivate(val)
    },

  }

}
</script>
